<template>
  <el-dialog title="排行榜" :visible="value" size="600px" :before-close="handleClose">
    <el-table :data="tableList">
      <el-table-column prop="rankNum" label="排名" width="150" align='center'>

      </el-table-column>
      <el-table-column label="用户信息" align='center'>
        <el-table-column prop="uid" label="uid" align='center'></el-table-column>
        <el-table-column prop="rid" label="rid" align='center'></el-table-column>
        <!-- <el-table-column prop="roomId" label="房间id" align='center'></el-table-column>
        <el-table-column prop="roomType" label="房间类型" align='center'></el-table-column> -->
      </el-table-column>
      <el-table-column prop="rankCount" label="得分" align='center'>
        <template #header="scope">
          <div>得分</div>
          <el-button type="primary" icon="el-icon-files" size="mini" @click="exportRank">导出数据</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import download from '@/utils/download.js'
import { activityRankReq, exportActivityRankReq } from '@/api/activityModelRequest'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    eventCode: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      downloadLoading: false,
      tableList: []
    }
  },
  watch: {
    eventCode(newVal) {
      if (newVal) {
        this.getRank(newVal)
      }
    }
  },
  mounted() {
    // this.getRank(this.eventCode)
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
    },
    async getRank(eventCode) {
      const res = await activityRankReq(eventCode)
      if (res.code === 0) {
        this.tableList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async exportRank() {
      console.log(1);
      if (this.downloadLoading) return
      this.downloadLoading = true
      const res = await exportActivityRankReq(this.eventCode)
      this.$message.success('开始下载')
      this.downloadLoading = false
      download(
        res,
        '活动排名数据' + this.eventCode
      )
    }
  }
}
</script>

<style scoped lang="scss">
.badge {
  margin-top: 8px;
}
</style>